import { getActivePinia, storeToRefs, } from 'pinia'
import { useMessagesLoaded, } from '@/assets/js/src/modules/lang/_composables/useMessagesLoaded'
import { useTranslation, } from '@/assets/js/src/util/composables/useTranslation'
import { computed, } from 'vue'
import { useRoute, } from 'vue-router'
import { useBibleRefs, } from '@/assets/js/src/util/composables/useBibleRefs'
import { REF_DEFAULT, useBibleStore, } from '@/assets/js/src/modules/bible/_pinia/bible'
import { useBooknamesStore, } from '@/assets/js/src/modules/bible/_pinia/booknames'
import { genHeadOverrides, } from '@/assets/js/src/layout/meta'
import { useHead, } from '@unhead/vue'

export const useHeadInfo = ({ synoptic, }) => {
    const { messagesLoaded, } = useMessagesLoaded([ 'synoptic', ])
    const { t, } = useTranslation()
    const activePinia = getActivePinia()
    const { params, } = useRoute()
    const { getRefByCanonicals, } = useBibleRefs()
    const { bibles, hasAmp, } = storeToRefs(useBibleStore(activePinia))
    const { booknamesLoaded, } = storeToRefs(useBooknamesStore(activePinia))

    const ampCanonical = computed(
        () => {
            if (!hasAmp.value(params.abbreviation)) {
                return ''
            }

            return activePinia.state.value.baseUrl + '/amp/synoptic/' + params.abbreviation + '/' + params.id
        }
    )

    const title = computed(
        () => {
            return messagesLoaded.value ? t('async.synoptic.title') : ''
        })

    const synopticBooks = computed(() => {
        return booknamesLoaded.value
            ? Object.keys(synoptic.value).map((key) => getRefByCanonicals({
                canonicals: synoptic.value[key].verses.map((verse) => verse.canonical),
                type: REF_DEFAULT,
            }))
            : []
    })

    const description = computed(
        () => {
            return messagesLoaded.value ? t('async.synoptic.description', {
                verses: synopticBooks.value.join(', '),
                bible: bible.value.name,
            }) : ''
        })

    const bible = computed(() => {
        return bibles.value[params.abbreviation] || ''
    })

    useHead(genHeadOverrides({ title, description, ampCanonical, }))

    return {
        bible,
        booknamesLoaded,
    }
}
